import $ from 'jquery'
import Swiper from 'swiper';
import { Navigation, Manipulation, FreeMode } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/manipulation';
import 'swiper/css/free-mode';
import { sentryAPIErrorV2 } from './module_common';

const needMoreCarouselItems = function(container) {
    if (container.data('reachEnd') === 1) return false
    const items = container.find(".swiper-slide").length
    const limit = container.data('limit')
    const offset = container.data('offset')
    const remainder = offset % limit
    if (remainder === 0 && items === offset + limit) return true
    return false
}

const loadCards = function (searchEndPoint, content, limit, offset, success, done){
    $.ajax({
      method: "POST",
      url: searchEndPoint,
      data: {
          contenttype: content,
          limit: limit,
          offset: offset
      },
      dataType: 'json',
      success: function(data){
        success(data)
      },
      error: function(err){
        const contextData = {
            functiondata:{
                function: "loadCards",
                url: searchEndPoint,
                contentType: content,
                limit: limit,
                offset: offset
            }
        }
        sentryAPIErrorV2(new Error("Error loading cards", {cause: err}), contextData)
      }
    }).done(function () {
        done();
    })
}

const loadCardDone = function(container) {
    return function(){
        container.data('loading', 0)
    }
}
  
const updateCards = function(container) {
    return function (data) {
        if (data.cards.length === 0){
            // Using the data() method to update data does not affect attributes in the DOM!
            container.data('reachEnd', 1)
            return
        }
        const sw = container.get(0).swiper
        sw.appendSlide(data.cards)
        const oldOffset = container.data('offset')
        const newOffset = oldOffset + data.cards.length
        container.data('offset', newOffset)
        if (data.cards.length < container.data('limit')){
            container.data('reachEnd', 1)
        }
    }
}

// Activate pagination item load with:
// * provide a searchCardsEndpoint
// * set on swiper container some html data attribute: contentType, limit, offset, reachEnd
// this will fire a POST call to the given searchCardsEndpoint with contentType, limit and offset data
export function defaultCarouselSetupVisitor (containerClass, outClass, mobileSlides, tabletSlides, desktopSlides, desktopBigSlides, searchCardsEndpoint) {
    const outSelector = "."+outClass;
    const containerSelector = "."+containerClass
    const swiper_cont = $(containerSelector);
    if (swiper_cont.length === 0) return

    var swiper = new Swiper(containerSelector, {
        modules: [Navigation, Manipulation, FreeMode],
        slidesPerView: mobileSlides,
        slidesPerGroup: 1,
        spaceBetween: 16,
        freeMode: {
            enabled: true,
        },
        watchSlidesProgress: true,
        navigation: {
            enable: false
        },
        allowTouchMove: true,
        breakpoints: {
            // when window width is >= 768px
            768: {
                slidesPerView: tabletSlides,
                slidesPerGroup: 1,
                allowTouchMove: true,
                spaceBetween: 16,
                freeMode: {
                    enabled: true,
                },
                navigation: {
                    enable: false
                },
            },
            992: {
                slidesPerView: desktopSlides,
                slidesPerGroup: desktopSlides,
                allowTouchMove: false,
                spaceBetween: 24,
                freeMode: {
                    enabled: false,
                },
                navigation: {
                    enabled: true,
                    nextEl: outSelector + ' .swiper-button-next',
                    prevEl: outSelector + ' .swiper-button-prev',
                },
            },
            1199: {
                allowTouchMove: false,
                slidesPerView: desktopBigSlides,
                slidesPerGroup: desktopBigSlides,
                spaceBetween: 24,
                freeMode: {
                    enabled: false,
                },
                navigation: {
                    enabled: true,
                    nextEl: outSelector + ' .swiper-button-next',
                    prevEl: outSelector + ' .swiper-button-prev',
                },
            }
        },
        on: {
            init: function (sw) {
                swiper_cont.addClass("ready")
                swiper_cont.addClass("mobile-ready")
            },
        }
    });

    window.swiper = swiper

    // paginated carousel init
    if (!searchCardsEndpoint || !swiper_cont.data('contenttype')) return
    if (swiper_cont.length == 0) return

    swiper.on('activeIndexChange', function(){
        if (swiper_cont.data('loading') === 1) return
        const limit = swiper_cont.data('limit');
        const contType = swiper_cont.data('contenttype')

        let slidePerView = swiper.params.slidesPerView
        if (slidePerView === "auto") {
            // swiper-slide-visible class is added with watchSlidesProgress=true
            slidePerView = $(".swiper-slide-visible").length
        }

        // max index of card in view
        const displayedMaxItem = (swiper.activeIndex + (Math.round(slidePerView)))
        const actualOffset = swiper_cont.data('offset')
        
        const threshold = actualOffset + limit
        // comparePlus define when starts to load more items
        const comparePlus = 2
        const currentCompare = displayedMaxItem + comparePlus


        if (currentCompare >= threshold) {
            const need = needMoreCarouselItems(swiper_cont)
            if (need) {
                swiper_cont.data('loading', 1)
                loadCards(
                    searchCardsEndpoint, 
                    contType, 
                    limit, 
                    actualOffset + limit, 
                    updateCards(swiper_cont), 
                    loadCardDone(swiper_cont)
                )
            }
        }
    })
}

